import { HoneycombWebSDK, GlobalErrorsInstrumentation, WebVitalsInstrumentation } from '@honeycombio/opentelemetry-web';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { v4 as uuidv4 } from 'uuid';

const IGNORE_URLS = [
  /google-analytics/,
  /optimizely/,
  /pinterest/,
  /doubleclick/,
  /qualtrics/,
  /traces/,
  /onetrust/,
  /vercel-insights/,
  /static\.sumup\.com/,
  /_next\/static/,
  /_vercel/,
  /api\.mapbox\.com/,
  /events\.mapbox\.com/,
];

const sessionId = uuidv4();

const sdk = new HoneycombWebSDK({
  serviceName: 'hotpink-ordering',
  tracesEndpoint: process.env.NEXT_PUBLIC_OTEL_EXPORTER_ENDPOINT,
  skipOptionsValidation: true,
  headers: {
    Authorization: `Basic ${process.env.NEXT_PUBLIC_OTEL_EXPORTER_AUTH_TOKEN}`,
    'X-Sumup-Vercel-Proof': process.env.NEXT_PUBLIC_OTEL_VERCEL_PROOF as string,
  },
  sessionProvider: {
    getSessionId: () => sessionId,
  },
  resourceAttributes: {
    'vercel.deployment_id': process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID,
    'sumup.org.tribe': 'tribe-pos',
    'sumup.org.squad': 'squad-order-and-pay',
    'sumup.org.chat': '#qr-order-and-pay-questions',
    'vcs.repository.name': 'orderandpay-ordering',
    'vcs.repository.url.full': 'https://github.com/sumup/orderandpay-ordering',
  },
  instrumentations: [
    new FetchInstrumentation({
      propagateTraceHeaderCorsUrls: [/./],
      ignoreNetworkEvents: true,
      ignoreUrls: IGNORE_URLS,
    }),
    new XMLHttpRequestInstrumentation({
      propagateTraceHeaderCorsUrls: [/./],
      ignoreNetworkEvents: true,
      ignoreUrls: IGNORE_URLS,
    }),
    new DocumentLoadInstrumentation({
      ignoreNetworkEvents: true,
    }),
    new UserInteractionInstrumentation(),
    new WebVitalsInstrumentation(),
    new GlobalErrorsInstrumentation({
      applyCustomAttributesOnSpan: (span) => {
        span.setAttribute('library.name', 'ordering-frontend');
      },
    }),
  ],
});

sdk.start();
